package com.wintermar.inspection.util

enum class ClientType(val clientName: String) {
    APP("InspectionApp"),
    WEB("WebDashboard")
}
